import { all, call, takeLatest } from 'redux-saga/effects';

import { createPaidService, editPaidService, loadPaidServices } from 'api/paidServices';
import { PAID_SERVICES_ACTION_TYPES } from 'store/actions/paidServices.actions';
import { getRange } from 'utils/rangeHelpers';
import { getRangeDate } from 'utils/dateHelpers';

function* loadPaidServicesFlow({payload, resolve, reject}) {
  try {
    const { createdAt, packagePrice, ...rest } = payload;
    let filters = rest;
    if (createdAt) {
      filters = {
        ...filters,
        ...getRangeDate('createdAt', createdAt),
      }
    }
    if (packagePrice) {
      filters = {
        ...filters,
        ...getRange('packagePrice', packagePrice)
      }
    }
    const {data} = yield call(loadPaidServices, filters)
    yield call(resolve, {
      items: data['hydra:member'],
      total: data['hydra:totalItems'],
    })
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* createPaidServicesFlow({ payload, resolve, reject }) {
  try {
    const { data } = yield call(createPaidService, payload)
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

function* editPaidServicesFlow({ payload, resolve, reject }) {
  try {
    const { data } = yield call(editPaidService, payload)
    yield call(resolve, data)
  } catch (e) {
    yield call(reject, e.response.data)
  }
}

export default function* () {
  yield all([
    takeLatest(PAID_SERVICES_ACTION_TYPES.LOAD_PAID_SERVICES, loadPaidServicesFlow),
    takeLatest(PAID_SERVICES_ACTION_TYPES.CREATE_PAID_SERVICES, createPaidServicesFlow),
    takeLatest(PAID_SERVICES_ACTION_TYPES.EDIT_PAID_SERVICES, editPaidServicesFlow),
  ])
}